export default function instagramLoader() {
    const instagramArea = document.getElementById('mapiInstagram');

    function lazyInstagram() {
        $.ajax({
            url: mapi_ajax_data.ajaxUrl,
            type: 'POST',
            data: {
                action: 'mapi_instagram',
            },
            beforeSend: () => {

            },
            success: (response) => {
                $('#mapiInstagramContent').html(response);

            }
        })
    }

    if (instagramArea !== null) {
        const options = {
            rootMargin: '300px',
            threshold: 0
        }

        const observer = new IntersectionObserver(
            function (entries, self) {
                const isIntersecting = typeof entries[0].isIntersecting === 'boolean' ? entries[0].isIntersecting : entries[0].intersectionRatio > 0
                if (isIntersecting) {
                    lazyInstagram();
                    self.unobserve(instagramArea)
                }
            },
            options
        )

        observer.observe(instagramArea)
    }
}